import useGetQuery from '_api/queries/useGetQuery';
import { ConstantsNameDescriptions, GoalType } from '_api/types';

export const GET_GOAL_TYPE = 'get-goal-type';

export const useGetGoalType = () =>
  useGetQuery<ConstantsNameDescriptions<GoalType>[]>(
    () => `/constant/goal-type`,
    {},
    [GET_GOAL_TYPE],
    {
      refetchOnWindowFocus: false,
    },
  );
